<template>
    <span class="isolate inline-flex rounded-md shadow-sm">
      <button type="button" @click="gotoNext(0)" class="relative inline-flex items-center rounded-l-md border border-gray-300 bg-white px-2 py-2 text-sm font-medium text-gray-500 hover:bg-gray-50 focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500">
        <span class="sr-only">Previous</span>
        <ChevronLeftIcon class="h-5 w-5" aria-hidden="true" />
      </button>
      <button type="button" @click="gotoNext(1)" class="relative -ml-px inline-flex items-center rounded-r-md border border-gray-300 bg-white px-2 py-2 text-sm font-medium text-gray-500 hover:bg-gray-50 focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500">
        <span class="sr-only">Next</span>
        <ChevronRightIcon class="h-5 w-5" aria-hidden="true" />
      </button>
    </span>
  </template>
  
<script setup>
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/vue/20/solid'
import { ref, onMounted, onUnmounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';


const router = useRouter();
const route = useRoute();
const currentTagId = ref(route.params.id);

  const props = defineProps({
    tagsIds: Array
  });

  const emit = defineEmits(
    ['updateNextTag']
  );




function findNextElement(array, elementToFind, isNext) {
    const index = array.indexOf(+elementToFind);

    // Sprawdzamy, czy element istnieje
    if (index >= 0) {
        if (isNext) {
            // Jeśli element jest ostatnim, zwracamy pierwszy element
            if (index === array.length - 1) {
                // console.log(array[0]);
                return array[0];
            } else {
                // W przeciwnym razie zwracamy następny element
                // console.log(array[index + 1]);
                return array[index + 1];
            }
        } else {
            // Dla isNext == false, zwracamy poprzedni element
            if (index === 0) {
                // Jeśli element jest pierwszym, zwracamy ostatni element
                // console.log(array[array.length - 1]);
                return array[array.length - 1];
            } else {
                // W przeciwnym razie zwracamy poprzedni element
                // console.log(array[index - 1]);
                return array[index - 1];
            }
        }
    } else {
        // Zwracamy null, jeśli element nie istnieje
        return null;
    }
}


const gotoNext = (isNext) => {
      // console.log("gotoNext...")
      // console.log("props.tagsIds:", props.tagsIds)
      // console.log("currentTagId.value:", currentTagId.value)
      // console.log("route.params.id:", route.params.id)

      
      const nextTagId = findNextElement(props.tagsIds, route.params.id, isNext)
      // console.log("nextTagId:", nextTagId)
      emit('updateNextTag', nextTagId);
    };




const handleKeydown = (event) => {
  const activeElement = document.activeElement.tagName.toLowerCase();

  // Sprawdź, czy aktywny element nie jest polem input lub textarea
  if ((activeElement !== 'input' && activeElement !== 'textarea') && event.key === 'ArrowLeft') {
    gotoNext(0);
  }
  if ((activeElement !== 'input' && activeElement !== 'textarea') && event.key === 'ArrowRight') {
    gotoNext(1);
  }
};

onMounted(() => {
  window.addEventListener('keydown', handleKeydown);
});

onUnmounted(() => {
  window.removeEventListener('keydown', handleKeydown);
});


  </script>